import styles from './styles.module.scss';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Board } from '../../../components/Board';
import { LogicManagerSidebar } from '../../../components/LogicManagerSidebar';
import { ProfileBox } from '../../../components/ProfileBox';
import { hasPermission, verifyRoutePermissions } from '../../../globalFunctions';
import { User } from '../../../types';
import { EDIT_COMPONENTS, EditComponent } from './config/EditList';
import { Option } from '../../../components/Option';
import { NavButton } from '../../../components/NavButton';

export const LogicManagerMainRoute = () => {
    const getNivel = () => {
        const nivel = sessionStorage.getItem('nivel') || '1';
        return parseInt(nivel);
    };
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const navigate = useNavigate();
    const [nivel, setNivel] = useState<number>(getNivel());

    const renderOption = (option: EditComponent) => {
        if (hasPermission(option.permission, userAuth)) {
            return (
                <Option key={option.id} icon={option.icon} alt={option.name} route={option.route} />
            );
        }
    };

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'logicmanager.classes'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    const trocarNivel = () => {
        let nextNivel = nivel >= 4 ? 1 : nivel + 1;

        // verifica se existem módulos para o próximo nível com permissão
        while (
            EDIT_COMPONENTS.filter(
                module => module.level === nextNivel && hasPermission(module.permission, userAuth)
            ).length === 0
        ) {
            nextNivel = nextNivel >= 4 ? 1 : nextNivel + 1;

            // evita loop infinito caso nenhum módulo tenha permissão
            if (nextNivel === nivel) break;
        }

        setNivel(nextNivel);
        sessionStorage.setItem('nivel', nextNivel.toString());
    };

    return (
        <div className={styles.wrapper}>
            {userAuth.token && (
                <>
                    <ProfileBox user={userAuth} />
                    <LogicManagerSidebar />
                    <Board wrapperClass={styles.board}>
                        <div className={styles.titleBar}>
                            {nivel == 1 ? (
                                <h1>Gerenciamento da plataforma</h1>
                            ) : nivel == 2 ? (
                                <h1>Gerenciamento do website</h1>
                            ) : nivel == 3 ? (
                                <h1>Gerenciamento do teste de lógica computacional</h1>
                            ) : (
                                <h1>Jogo</h1>
                            )}
                        </div>

                        <div className={styles.optionsWrapper}>
                            {EDIT_COMPONENTS.filter(module => module.level === nivel).map(module =>
                                renderOption(module)
                            )}
                        </div>
                        <NavButton
                            icon='stat_2'
                            style={{ right: '5vw', top: '10vh'}}
                            onClick={trocarNivel}
                            title='Proximo Nivel'
                        />
                    </Board>
                </>
            )}
        </div>
    );
};
